import { toast } from '@/components/toast';
import { apiBlob } from './api';

export type PdfMode = 'preview' | 'print' | 'download';

/**
 * Preview (new tab), print (the browser's print dialog over a hidden frame) or download a PDF the
 * API renders. Errors become a toast.
 */
export async function pdfAction(
  mode: PdfMode,
  path: string,
  fileName: string,
  init?: RequestInit,
): Promise<void> {
  // open the tab before awaiting, so the browser treats it as the user's action
  const win = mode === 'preview' ? window.open('', '_blank') : null;
  try {
    const url = URL.createObjectURL(await apiBlob(path, init));
    if (mode === 'preview') {
      if (win) win.location.href = url;
      else window.location.assign(url);
    } else if (mode === 'download') {
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      a.remove();
    } else {
      const frame = document.createElement('iframe');
      frame.style.position = 'fixed';
      frame.style.width = '0';
      frame.style.height = '0';
      frame.style.border = '0';
      frame.title = fileName;
      frame.onload = () => {
        frame.contentWindow?.focus();
        frame.contentWindow?.print();
      };
      frame.src = url;
      document.body.appendChild(frame);
      setTimeout(() => frame.remove(), 120_000);
    }
    setTimeout(() => URL.revokeObjectURL(url), 120_000);
  } catch (e) {
    win?.close();
    toast(e instanceof Error ? e.message : String(e), { tone: 'error' });
  }
}

/** File name of a sales document's PDF, as the API names it. */
export function pdfFileName(label: string, number: string | null): string {
  return `${label.replace(/\s/g, '-')}-${number ?? 'draft'}.pdf`;
}
